/*
  CardsByBeard — verlanglijst.

  - Zonder account staat de lijst in de browser (localStorage).
  - Ingelogd wordt hij bij het account bewaard via de app (app-proxy, zie window.cbWens.pad).
    De pagina reageert altijd direct; opslaan gebeurt op de achtergrond en wordt bij de volgende
    pagina opnieuw geprobeerd als het niet lukte.
  - Wie als gast een lijst maakt en daarna inlogt, krijgt die lijst bij het account erbij.

  Instellingen komen uit layout/theme.liquid: window.cbWens = { klant, server, pad, pagina }.
  Knoppen: snippets/cb-wens-knop.liquid ([data-cb-wens]). Lijstpagina: sections/cb-wishlist.liquid.
*/
(function () {
  'use strict';

  var cfg = window.cbWens || {};
  var SLEUTEL = 'cb-verlanglijst';
  var MAX = 100;

  // ── Opslag in de browser ──
  function lees() {
    try {
      var s = JSON.parse(localStorage.getItem(SLEUTEL) || 'null');
      if (s && Array.isArray(s.items)) {
        return { items: s.items, erbij: s.erbij || [], weg: s.weg || [], klant: s.klant || null };
      }
    } catch (e) {}
    return { items: [], erbij: [], weg: [], klant: null };
  }

  function bewaar() {
    try {
      localStorage.setItem(SLEUTEL, JSON.stringify(staat));
    } catch (e) {}
  }

  var staat = lees();
  var klant = cfg.klant ? String(cfg.klant) : null;

  function zonder(lijst, id) {
    return lijst.filter(function (x) {
      return String(x) !== String(id);
    });
  }

  function heeft(id) {
    return staat.items.some(function (i) {
      return String(i.id) === String(id);
    });
  }

  // ── Bij het laden: browser en account op één lijn brengen ──
  function start() {
    if (!klant) {
      // Uitgelogd na een ingelogde sessie: lijst niet laten staan op een gedeeld apparaat
      if (staat.klant) staat = { items: [], erbij: [], weg: [], klant: null };
      bewaar();
      return;
    }

    if (staat.klant !== klant) {
      if (staat.klant) {
        // Ander account op dit apparaat: niets meenemen
        staat = { items: [], erbij: [], weg: [], klant: klant };
      } else {
        // Gast die nu inlogt: alles wat in de browser stond moet bij het account
        staat.erbij = staat.items.map(function (i) {
          return String(i.id);
        });
        staat.weg = [];
        staat.klant = klant;
      }
    }

    if (Array.isArray(cfg.server)) staat.items = voegSamen(cfg.server);
    bewaar();
    if (staat.erbij.length || staat.weg.length) stuur();
  }

  // Lijst van het account + wat hier nog niet is opgeslagen
  function voegSamen(server) {
    var bekend = {};
    staat.items.forEach(function (i) {
      bekend[String(i.id)] = i;
    });
    var uit = [];
    var gezien = {};
    staat.erbij.forEach(function (id) {
      if (bekend[id] && !gezien[id]) {
        gezien[id] = true;
        uit.push(bekend[id]);
      }
    });
    server.forEach(function (i) {
      var id = String(i.id);
      if (!gezien[id] && staat.weg.indexOf(id) === -1) {
        gezien[id] = true;
        uit.push({ id: id, handle: i.handle });
      }
    });
    return uit.slice(0, MAX);
  }

  // ── Opslaan bij het account ──
  var bezig = false;
  var timer = null;

  function plan() {
    if (!klant) return;
    clearTimeout(timer);
    timer = setTimeout(stuur, 700);
  }

  function stuur() {
    if (!klant || bezig || !cfg.pad) return;
    if (!staat.erbij.length && !staat.weg.length) return;
    var erbij = staat.erbij.slice();
    var weg = staat.weg.slice();
    bezig = true;

    fetch(cfg.pad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ toevoegen: erbij, verwijderen: weg }),
      keepalive: true,
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        bezig = false;
        if (!data || !data.ingelogd || !Array.isArray(data.items)) return; // blijft in de wachtrij
        // Alleen wat we verstuurd hebben is verwerkt; tussentijdse klikken blijven staan
        staat.erbij = staat.erbij.filter(function (id) {
          return erbij.indexOf(id) === -1;
        });
        staat.weg = staat.weg.filter(function (id) {
          return weg.indexOf(id) === -1;
        });
        staat.items = voegSamen(data.items);
        bewaar();
        teken();
        if (staat.erbij.length || staat.weg.length) plan();
      })
      .catch(function () {
        bezig = false;
      });
  }

  // ── Aan/uit zetten ──
  function wissel(id, handle) {
    id = String(id);
    var stond = heeft(id);
    if (stond) {
      staat.items = staat.items.filter(function (i) {
        return String(i.id) !== id;
      });
      if (klant) {
        staat.erbij = zonder(staat.erbij, id);
        if (staat.weg.indexOf(id) === -1) staat.weg.push(id);
      }
    } else {
      staat.items.unshift({ id: id, handle: handle });
      staat.items = staat.items.slice(0, MAX);
      if (klant) {
        staat.weg = zonder(staat.weg, id);
        if (staat.erbij.indexOf(id) === -1) staat.erbij.push(id);
      }
    }
    bewaar();
    teken();
    plan();
    return !stond;
  }

  // ── Knoppen en teller bijwerken ──
  // Alleen schrijven als er iets verandert: de MutationObserver onderaan reageert op elke wijziging
  function zet(el, tekst) {
    if (el.textContent !== tekst) el.textContent = tekst;
  }

  function teken() {
    document.querySelectorAll('[data-cb-wens]').forEach(function (knop) {
      var aan = heeft(knop.getAttribute('data-cb-wens'));
      if (knop.getAttribute('aria-pressed') === String(aan)) return;
      knop.setAttribute('aria-pressed', String(aan));
      var titel = knop.getAttribute('data-titel') || 'Dit product';
      knop.setAttribute('aria-label', titel + (aan ? ' van je verlanglijst halen' : ' op je verlanglijst zetten'));
      var tekst = knop.querySelector('[data-cb-wens-tekst]');
      if (tekst) zet(tekst, aan ? 'Op je verlanglijst' : 'Op verlanglijst');
    });

    var n = staat.items.length;
    document.querySelectorAll('[data-cb-wens-teller]').forEach(function (el) {
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
      zet(el, n > 99 ? '99+' : String(n));
    });
    // Lijstpagina: samenvatting en de knop "alles in winkelwagen"
    var raster0 = document.querySelector('[data-cb-wenslijst]');
    if (raster0) {
      var opVoorraad = raster0.querySelectorAll('li:not(.is-weg) [data-cb-quick-add]').length;
      var geladen = raster0.querySelectorAll('li[data-id]:not([hidden])').length;
      var tekst = n === 0 ? '' : n === 1 ? '1 product' : n + ' producten';
      if (n > 0 && geladen >= n) tekst += opVoorraad === n ? ', alles op voorraad' : ' · ' + opVoorraad + ' op voorraad';
      document.querySelectorAll('[data-cb-wens-samenvatting]').forEach(function (el) {
        zet(el, tekst);
      });
      var alles = document.querySelector('[data-cb-wens-alles]');
      if (alles && alles.hidden !== opVoorraad < 2) alles.hidden = opVoorraad < 2;
    }
    document.querySelectorAll('[data-cb-wenslijst] li[data-id]').forEach(function (li) {
      li.classList.toggle('is-weg', !heeft(li.getAttribute('data-id')));
    });
    var leeg = document.querySelector('[data-cb-wens-leeg]');
    var raster = document.querySelector('[data-cb-wenslijst]');
    if (leeg && raster) {
      var verberg = n > 0 || raster.children.length > 0;
      if (leeg.hidden !== verberg) leeg.hidden = verberg;
    }
  }

  // Alle producten op voorraad in één keer in de winkelwagen (alleen producten met één variant)
  document.addEventListener('click', function (event) {
    var alles = event.target.closest('[data-cb-wens-alles]');
    if (!alles || alles.disabled) return;
    var items = [];
    document.querySelectorAll('[data-cb-wenslijst] li:not(.is-weg) [data-cb-quick-add]').forEach(function (knop) {
      var item = { id: Number(knop.getAttribute('data-cb-quick-add')), quantity: 1 };
      if (knop.hasAttribute('data-cb-marge')) item.properties = { Btw: 'margeregeling (niet aftrekbaar)' };
      items.push(item);
    });
    if (!items.length) return;
    var oud = alles.textContent;
    alles.disabled = true;
    alles.textContent = 'Bezig…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else {
          window.location.href = root + 'cart';
        }
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cb-verlanglijst', cartData: state });
        }
        alles.textContent = oud;
        alles.disabled = false;
      })
      .catch(function (fout) {
        // Bijvoorbeeld: niet genoeg voorraad voor één van de producten
        alles.textContent = (fout && fout.description) || 'Toevoegen lukte niet';
        setTimeout(function () {
          alles.textContent = oud;
          alles.disabled = false;
        }, 3500);
      });
  });

  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-cb-wens]');
    if (!knop) return;
    event.preventDefault();
    event.stopPropagation();
    wissel(knop.getAttribute('data-cb-wens'), knop.getAttribute('data-handle'));
  });

  // ── Lijstpagina: per product de gewone productkaart ophalen ──
  function bouwLijst() {
    var raster = document.querySelector('[data-cb-wenslijst]');
    if (!raster) return;
    var items = staat.items.slice();
    var plekken = items.map(function (item) {
      var li = document.createElement('li');
      li.setAttribute('data-id', item.id);
      li.hidden = true;
      raster.appendChild(li);
      return li;
    });

    var volgende = 0;
    function werk() {
      if (volgende >= items.length) return;
      var i = volgende++;
      var item = items[i];
      fetch('/products/' + encodeURIComponent(item.handle) + '?section_id=cb-wens-kaart')
        .then(function (res) {
          if (res.status === 404) throw new Error('weg');
          return res.text();
        })
        .then(function (html) {
          var kaart = new DOMParser().parseFromString(html, 'text/html').querySelector('.cb-pcard');
          if (!kaart) throw new Error('leeg');
          plekken[i].appendChild(document.importNode(kaart, true));
          plekken[i].hidden = false;
        })
        .catch(function (fout) {
          plekken[i].remove();
          // Product bestaat niet meer: van de lijst halen
          if (fout && fout.message === 'weg' && heeft(item.id)) wissel(item.id, item.handle);
        })
        .then(function () {
          teken();
          werk();
        });
    }
    for (var k = 0; k < 4; k++) werk();
  }

  // Nieuwe kaarten (meer laden, aanbevelingen) krijgen ook de juiste staat
  var wacht = false;
  function later() {
    if (wacht) return;
    wacht = true;
    requestAnimationFrame(function () {
      wacht = false;
      teken();
    });
  }

  function klaar() {
    start();
    teken();
    bouwLijst();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', klaar);
  else klaar();

  // Zelfde lijst in een ander tabblad aangepast
  window.addEventListener('storage', function (event) {
    if (event.key !== SLEUTEL) return;
    staat = lees();
    teken();
  });
})();
